import { defaultTableConfig, GlobalListTable } from '@global-dax-ad-platform/dax-components';
import {
  ArrowDownSmallIcon,
  ArrowUpSmallIcon,
} from '@global-engineering-shared/gweb-material-icons-global-next';
import { ListTableProvider, useListTable } from '@global-engineering-shared/gweb-material-lab';
import { Row } from '@global-engineering-shared/gweb-material-types';
import { Box } from '@global-engineering-shared/gweb-material-ui';

import BroadsignFramesRow from 'features/EntityDetails/components/BroadsignFramesRow/';
import useStyles from 'features/EntityDetails/components/EntityDetails/LinkedFramesDetailTable/LinkedFramesDetailTable.styles';
import useLinkedFramesDetailTableColumns from 'features/EntityDetails/components/EntityDetails/LinkedFramesDetailTable/utils/useLinkedFramesDetailTableColumns';
import { TLinkedAssetFramesTableEntity } from 'types/tableEntityType';

type LinkedFramesTableNewProps = {
  data: TLinkedAssetFramesTableEntity[];
};

const LinkedFramesDetailTable: React.FC<LinkedFramesTableNewProps> = ({ data }) => {
  const classes = useStyles();

  const renderWithStatus = data.length > 0 && data[0].status !== null;

  const columns = useLinkedFramesDetailTableColumns(renderWithStatus);

  const instance = useListTable<TLinkedAssetFramesTableEntity>({
    data,
    columns,
    rowCount: data.length,
    getRowId: (row) => row.spaceId,
    ...defaultTableConfig,
    meta: {
      ...defaultTableConfig.meta,
      renderCollapsableRow: ({ row }: { row: Row<TLinkedAssetFramesTableEntity> }) => (
        <Box className={classes.collapsibleRowContainer}>
          <BroadsignFramesRow
            broadsignFrames={row.original.broadsignFrames.current}
            previousBroadsignFrames={row.original.broadsignFrames.previous}
          />
        </Box>
      ),
    },
    componentProps: {
      ...defaultTableConfig.componentProps,
      ListTableHeadSortLabelProps: {
        sortAscIcon: <ArrowUpSmallIcon />,
        sortDescIcon: <ArrowDownSmallIcon />,
      },
    },
  });

  return (
    <ListTableProvider instance={instance}>
      <GlobalListTable<TLinkedAssetFramesTableEntity> data-tc="linked-frames-details-table" />
    </ListTableProvider>
  );
};

export default LinkedFramesDetailTable;
